// extracted by mini-css-extract-plugin
module.exports = {"Container":"SectionOne_Container__31MiF","Title":"SectionOne_Title__2jKqa","Boxes":"SectionOne_Boxes__2UtGk"};